import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/logo.svg'


const _withScopeId = n => (_pushScopeId("data-v-349a27f7"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main" }
const _hoisted_2 = { class: "left" }
const _hoisted_3 = { class: "right" }
const _hoisted_4 = { class: "form-container" }
const _hoisted_5 = /*#__PURE__*/_createStaticVNode("<img src=\"" + _imports_0 + "\" alt=\"Logo\" data-v-349a27f7><h3 class=\"bold-h3\" data-v-349a27f7>Sua conta foi criada com sucesso</h3><div class=\"icon-check-container\" data-v-349a27f7><i class=\"bi bi-check-circle\" data-v-349a27f7></i></div><p class=\"informative-form bold-p\" data-v-349a27f7></p>", 4)
const _hoisted_9 = { class: "informative-container" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "informative-item-1 regular-p" }, "Efetuar ", -1))
const _hoisted_11 = { class: "bold-p" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "login", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoginCarousel = _resolveComponent("LoginCarousel")!
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_LoginCarousel)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createElementVNode("div", _hoisted_9, [
          _hoisted_10,
          _createElementVNode("label", _hoisted_11, [
            _createVNode(_component_RouterLink, {
              to: { name: 'login' },
              class: "informative-item-2"
            }, {
              default: _withCtx(() => [
                _hoisted_12
              ]),
              _: 1
            })
          ])
        ])
      ])
    ])
  ]))
}